import { ProgressModule } from 'modules';

export const ProgressScreen = () => {
  return <ProgressModule />;
};
